module.exports = __webpack_public_path__ + "img/max_ticket.3286f985.svg";